var $3018f20d66d40eab$exports = {};
$3018f20d66d40eab$exports = {
    "help": `\u{414}\u{43E}\u{432}\u{456}\u{434}\u{43A}\u{430}`,
    "info": `\u{406}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{44F}`
};


export {$3018f20d66d40eab$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
